import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectieTypeSwitcherComponent } from './directie-type-switcher.component';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        DirectieTypeSwitcherComponent
    ],
    imports: [
        CommonModule,
        MaterialModule
    ],
    exports: [DirectieTypeSwitcherComponent],
})
export class DirectieTypeSwitcherModule { }
